import { render, staticRenderFns } from "./DomainTagInput.vue?vue&type=template&id=3eb2ff2a&"
import script from "./DomainTagInput.vue?vue&type=script&lang=js&"
export * from "./DomainTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports